"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 5.723a1.5 1.5 0 0 1 2.244-1.302l10.985 6.277a1.5 1.5 0 0 1 0 2.604L7.244 19.58A1.5 1.5 0 0 1 5 18.277zm1.748-.434A.5.5 0 0 0 6 5.723v12.554a.5.5 0 0 0 .748.434l10.985-6.277a.5.5 0 0 0 0-.868z"
}), 'Play');
//# sourceMappingURL=index.js.map